/**
 * @file  services/cache.ts
 * @description  cache service. The level is caching server/client is managed by this service
 *
 * @author ogarcia (ozkary)
 *
 */
import moment from 'moment';

/**
 * Enumerates the cache keys.
 */
export enum Key {
  audit = 'audit',
  auth = 'authorization',
  rates = 'rates',
  services = 'services',
  vehicle = 'vehicle',
  contact = 'contact',
  quotesCache = 'quotes-cache',
  product = 'product',
  rate = 'rate',
  surcharges = 'surcharges',
  coverages = 'coverages',
  plan = 'plan',
  contractRequest = 'contract-request',
  contract = 'contract',
  currentContract = 'current-contract',
  signature = 'signature',
  payment = 'payment',
  discounts = 'discounts',
  finance = 'finance'
}

/**
 * sets an object on the cache
 * @param name key name
 * @param doc the JSON document
 * @returns void
 */
export const setItem = <T>(name: string, doc: T): void => {
  return sessionStorage.setItem(
    name,
    JSON.stringify(doc, function (key, value) {
      if (this[key] instanceof Date) {
        return moment(this[key]).format('YYYY-MM-DD HH:mm:ss');
      }

      return value;
    })
  );
};

/**
 * retrives an object from the cache
 * @param name key name
 * @returns the object of type T
 */
export const getItem = <T>(name: string): T => {
  const doc = sessionStorage.getItem(name) as string;
  const obj: T = JSON.parse(doc) as T;
  return obj;
};

/**
 * removes an items from storage
 * @param name key name
 */
export const removeItem = (name: string): void => {
  sessionStorage.removeItem(name);
};

/**
 * checks if an item exist in the cache
 * @param name the key name
 * @returns true if the item exists
 */
export const exists = (name: string): boolean => {
  const doc = sessionStorage.getItem(name);
  return doc !== null && doc !== undefined && doc !== '';
};
